import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { formatAxiosErrorMessage, postOrThrow } from "../../../../_api";
import { BlogForm } from "../BlogForm/BlogForm";
import { Alert, Container, Stack, Text, Title } from "@mantine/core";

export const NewArticle: React.FC = () => {
  const history = useHistory();
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <Container size="md" py="xl" pb={250}>
      <Stack gap="lg">
        <Title order={1}>Nowy artykuł</Title>
        {submitError ? (
          <Alert
            color="red"
            variant="filled"
            title="Nie zapisano artykułu"
            withCloseButton
            onClose={() => setSubmitError(null)}
            mb="md"
            style={{ position: "sticky", top: 0, zIndex: 200 }}
          >
            <Text size="sm" c="white" style={{ whiteSpace: "pre-wrap" }}>
              {submitError}
            </Text>
          </Alert>
        ) : null}
        <BlogForm
          onSubmit={async (values) => {
            setSubmitError(null);
            try {
              const res = await postOrThrow("blog", values);
              if (res) {
                history.push("/blog");
              }
            } catch (e) {
              setSubmitError(formatAxiosErrorMessage(e));
            }
          }}
        />
      </Stack>
    </Container>
  );
};
